
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { Customer } from '@/models/accounting/Customer'
import { Journal } from '@/models/accounting/Journal'
import { Invoice } from '@/models/accounting/Invoice'
import { InvoiceLine } from '@/models/accounting/InvoiceLine'
import { formatCurrency } from '@/utils/currency'
import moment from 'moment'

@Component({
	methods: { formatCurrency, moment },
	components: {}
})
export default class InvoicePreview extends Vue {
	@Prop({ required: false, default: null })
	invoice!: Invoice | null

	@Prop({ required: false, default: null })
	selectedCustomer!: Customer | null

	@Prop({ required: false, default: null })
	selectedJournal!: Journal | null

	@Prop({ required: false, default: [] })
	invoiceLines!: Array<InvoiceLine>

	get invoiceTotal(): number {
		return this.invoiceLines.reduce((acc, line) => {
			return acc + line.total
		}, 0)
	}

	get formattedTotalInclVAT() {
		// eslint-disable-next-line no-unused-expressions
		this.invoiceTotal // just referencing the property so that it stays in sync, work around array binding issue
		return formatCurrency(
			this.invoiceLines.reduce((acc, line) => {
				return acc + line.totalInclVAT
			}, 0)
		)
	}
}
